import Flex from '@components/Flex/Flex';
import { styled } from '@mui/material';

export const StyledContainer = styled(Flex)(({ theme }) => ({
  width: '100%',
  overflow: 'auto',
  flexFlow: 'row nowrap',
  gap: theme.spacing(9),
  marginTop: theme.spacing(12),
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(8),
  },
}));

export const StyledItem = styled(Flex)(({ theme }) => ({
  flexDirection: 'column',
  backgroundColor: theme.palette.common.white,
  flex: 1,
  minWidth: 340,
  height: '95%',
  borderRadius: theme.spacing(11),
  border: `1px solid ${theme.palette.grey[500]}`,
  padding: theme.spacing(13),
  [theme.breakpoints.down('sm')]: {
    height: 'auto',
    minWidth: '90%',
    padding: theme.spacing(8, 13),
  },
}));

export const ImageContainer = styled(Flex)(({ theme }) => ({
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  height: 200,
  marginBottom: theme.spacing(4),
}));

export const TextContainer = styled(Flex)(({ theme }) => ({
  flexDirection: 'column',
  flex: 1,
  justifyContent: 'flex-start',
}));

export const StyledImage = styled('img')(({ theme }) => ({
  objectFit: 'contain',
  height: '100%',
  alignSelf: 'flex-end',
  [theme.breakpoints.up('md')]: {
    maxWidth: '100%',
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));
